var $ad6bd5774fab2049$exports = {};
(function() {
    const settingsDescriptions = [
        ...document.querySelectorAll('[data-setting-description]')
    ];
    const onClick = ({ currentTarget: currentTarget })=>{
        if (currentTarget.classList.contains('active')) return;
        const { dataset: { settingDescription: settingDescription }, parentElement: parentElement } = currentTarget;
        parentElement.querySelector('[data-setting-description].active').classList.remove('active');
        parentElement.nextElementSibling.querySelector('.active').classList.remove('active');
        parentElement.nextElementSibling.querySelector(`[data-setting-image=${settingDescription}]`).classList.add('active');
        currentTarget.classList.add('active');
    };
    settingsDescriptions.map((item)=>{
        item.onclick = onClick;
    });
})();


//# sourceMappingURL=web_platform.a7877850.js.map
